exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-menu-item-selected-2Uo0o{background:#ebebeb}", ""]);

// Exports
exports.locals = {
	"menu-item-selected": "index-menu-item-selected-2Uo0o"
};